export default "__VITE_ASSET__Jw5MYmUr__"